import { Client } from "@/clients/client";
import { OperationMonitorRequestParams } from "@/clients/OperationMonitorClient";

export class OperationMonitorService {
  constructor(private client: Client) {}

  public async getRvsSensors(params: OperationMonitorRequestParams): Promise<any> {
    return this.client.operationMonitorClient.getRvsSensors(params);
  }

  public async getRvsSensorSummary(params: OperationMonitorRequestParams): Promise<any> {
    return this.client.operationMonitorClient.getRvsSensorSummary(params);
  }

  public async getRvsBatteryByCompany(params: OperationMonitorRequestParams): Promise<any> {
    return this.client.operationMonitorClient.getRvsBatteryByCompany(params);
  }

  public async getRvsSensorsExport(params: OperationMonitorRequestParams): Promise<any> {
    return this.client.operationMonitorClient.getRvsSensorsExport(params);
  }
}
